import React, { useEffect, useState } from "react";
import arrowR from "./../assets/arrowR.png";

const Step1 = ({
  selectedManagers,
  t,
  managersData,
  hoveredManager,
  setHoveredManager,
  toggleManagerSelection,
  setCurrentStep,
  lang 
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
    <div>
      <h1 className="h1Config">{t.titleStep1}</h1>
      <p className="subTitle">{t.subtitleStep1}</p>

      <button className="selezionati">
          {t.selectedLabel} {selectedManagers.length}
        </button>

      <div className="managers-grid">
        {managersData.map((manager) => {
          const isSelected = selectedManagers.some((m) => m.id === manager.id);
          const isHovered = hoveredManager === manager.id;

          // IMMAGINI PER MOBILE E DESKTOP
          const desktopImageSrc = isSelected
            ? manager.images.active[lang]
            : isHovered
            ? manager.images.hover
            : manager.images.default;

          const mobileImageSrc = isSelected
            ? manager.images.mobileSelected[lang]
            : manager.images.mobile[lang];

          return (
            <div
              key={manager.id}
              className={`manager-card ${isSelected ? "selected" : ""}`}
              onClick={() => toggleManagerSelection(manager)}
              onMouseOver={() => !isMobile && setHoveredManager(manager.id)}
            >
              {/* Immagine Desktop */}
              <img
                src={desktopImageSrc}
                alt={manager.name}
                className="manager-image desktop"
              />

              {/* Immagine Mobile */}
              <img
                src={mobileImageSrc}
                alt={manager.name}
                className="manager-image mobile"
              />
            </div>
          );
        })}
      </div>
    
    </div>
    <div class="navigation-buttons button-container mt-50">
    <button onClick={() => setCurrentStep(2)} disabled={selectedManagers.length === 0}>
    {t.avanti} <img src={arrowR} alt="Freccia destra" />
    </button>
    </div>
    
   </>
  );
};

export default Step1;
